import { RouteObject, Navigate } from "react-router-dom";
import MainRoot from "../components/root/MainRoot";
import { getCookie } from "../utils/cookies";
import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/auth/login/Login";
import NotFound from "../pages/not-found/NotFound";
import AuthRoot from "../components/root/AuthRoot";
import AllStores from "../pages/all-stores/AllStores";
import Users from "../pages/users/Users";
import Audit from "../pages/audit/Audit";
import StoresPercentages from "../pages/stores-percentages/StoresPercentages";
import AllShipping from "../pages/all-shipping/AllShipping";
import Currency from "../pages/currency/Currency";
import Payments from "../pages/payments/Payments";
import Settings from "../pages/settings/Settings";
import Categories from "../pages/categories/Categories";
import Info from "../pages/info/Info";
import Products from "../pages/products/Products";
import Brands from "../pages/brans/Brands";
import Attributes from "../pages/attributes/Attributes";
import ProductDetail from "../pages/products/detail/ProductDetail";
import PayoutReport from "../pages/audit/payout-report/PayoutReport";
import TaxReport from "../pages/audit/tax-report/TaxReport";
import StoreAnalytics from "../pages/audit/store-analytics/StoreAnalytics";
import AuditSettings from "../pages/audit/AuditSettings.tsx/AuditSettings";
import InstallmentBanks from "../pages/audit/installment-banks/InstallmentBanks";
import Notifications from "../pages/notifications/Notifications";
import Messages from "../pages/messages/Messages";
import CountriesCities from "../pages/countries-cities/CountriesCities";

const access_token = getCookie("LuxMartAdminDashboardAccessToken");

const ROUTES: RouteObject[] = [
  {
    path: "/",
    element: (
      <Navigate to={`${access_token ? "/dashboard" : "/auth/login"}`} replace />
    ),
  },
  {
    path: "/dashboard",
    element: <MainRoot />,
    children: [
      {
        path: "/dashboard/",
        element: <Dashboard />,
      },
      {
        path: "all-stores",
        element: <AllStores />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "audit",
        element: <Audit />,
      },
      {
        path: "audit/payout-report",
        element: <PayoutReport />,
      },
      {
        path: "audit/tax-report",
        element: <TaxReport />,
      },
      {
        path: "audit/store-analytics",
        element: <StoreAnalytics />,
      },
      {
        path: "audit/settings",
        element: <AuditSettings />,
      },
      {
        path: "audit/installment-banks",
        element: <InstallmentBanks />,
      },
      {
        path: "stores-percentages",
        element: <StoresPercentages />,
      },
      {
        path: "all-shipping",
        element: <AllShipping />,
      },
      {
        path: "currency",
        element: <Currency />,
      },
      {
        path: "payments",
        element: <Payments />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "categories",
        element: <Categories />,
      },
      {
        path: "products",
        element: <Products />,
      },
      {
        path: "products/:id/:product_id",
        element: <ProductDetail />,
      },
      {
        path: "brands",
        element: <Brands />,
      },
      {
        path: "attributes",
        element: <Attributes />,
      },
      {
        path: "info",
        element: <Info />,
      },
      {
        path: "notifications",
        element: <Notifications />,
      },
      {
        path: "messages",
        element: <Messages />,
      },
      {
        path: "countries-cities",
        element: <CountriesCities />,
      },
    ],
  },
  {
    path: "/auth",
    element: <AuthRoot />,
    children: [
      {
        index: true,
        element: <Navigate to="login" replace />,
      },
      {
        path: "/auth/login",
        element: <Login />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default ROUTES;
